import React, { Component } from 'react'
import MentionEditor from "../../common/components/mention-editor";
import * as utils from "../../utils";
import { postReply } from "../actions";
import Timer from "../../../common/timer";

const ReplyForm = React.createClass({
  shouldComponentUpdate(nextProps, nextState) {
    return (this.state.comment !== nextState.comment) || (this.state.focus !== nextState.focus);
  },
  getInitialState: function () {
    this.blurTimer = new Timer(500, 1);
    evite.listenTo(this.blurTimer, Timer.TICK, this.handleBlurTimer);

    return {
      focus: false
    }
  },
  render: function () {
    const { focus } = this.state;
    const fieldsetClassName = focus || this.props.buttonVisible? "has-focus": "";

    const suggestionsOnTop = this.props.suggestionsOnTop || false;

    const defaultPlaceholder = focus && evite.features.isEnabled('mentions')?
      'Use @ to mention a guest.':
      'Write a reply...';
    return (
      <form
        onSubmit={this.handleReplySubmit}
        className="reply-form"
        method="post"
        action="#"
        ref={(c) => {
          this.formElement = c;
        }}
      >
        <fieldset className={fieldsetClassName}>
          <MentionEditor
            onSubmit={this.handleReplySubmit}
            publicRef={(c) => this.mentionEditor = c}
            placeholder={defaultPlaceholder}
            singleLineInput={true}
            onFocus={this.handleFocus}
            onBlur={this.handleBlur}
            suggestionsOnTop={suggestionsOnTop}
          />
          <button type="submit" className="comment-button" onClick={this.handleReplySubmit}>
            Reply
          </button>
        </fieldset>
      </form>
    )
  },

  replyToReply: function (reply) {
    const scrollTop = $(this.formElement).offset().top - 140;

    if (utils.isIpad() || utils.isIphone()) {
      this.mentionEditor.focus();
    } else {
      $('html, body').animate({ scrollTop }, 400, () => {
        this.mentionEditor.focus();
      });
    }

    evite.requestIdleCallback(() => {
      this.mentionEditor.clearComment();
      this.mentionEditor.appendMentionById(reply.creator_id);

      if(document.body.classList.contains('modal-open')){
        this.formElement.scrollIntoView();
      }
      else if (!utils.isIpad() && !!utils.isIphone()) {
        this.formElement.scrollIntoView();

        var header = document.getElementById('header');
        if (header) {
          const topPadding = 100;
          window.scrollTo(window.pageXOffset, window.pageYOffset - header.clientHeight - topPadding)
        }
      }

      this.setState({ focus: true });
    });
  },

  handleFocus: function (e) {
    this.blurTimer.stop();
    this.setState({ focus: true });
  },
  handleBlur: function (e) {
    if (this.mentionEditor.comment === '') {
      this.blurTimer.restart();
    }
  },

  handleBlurTimer: function(e){
    if (this.formElement) {
      this.setState({ focus: false });
    }
  },
  handleReplySubmit: function (e) {
    e.preventDefault();

    evite.requestIdleCallback(() => {
      const { comment, mentions } = this.mentionEditor;

      if (comment) {
        postReply(this.props.postId, comment, mentions);
        this.clearInput();
      }

      if (this.props.onSubmit) {
        this.props.onSubmit(e);
      }
    });
  },
  clearInput: function () {
    this.mentionEditor.clearComment();
  }
});

export default ReplyForm;



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/posts/components/reply-form.es6